import { Component, OnInit, Input } from '@angular/core';
import { BotonTipo } from '../boton';

@Component({
  selector: 'app-boton-toggle',
  templateUrl: './boton-toggle.component.html',
  styleUrls: ['./boton-toggle.component.scss']
})
export class BotonToggleComponent implements OnInit {
  @Input() botonesTipo: BotonTipo; // tipo actual de los botones


  constructor() {
    this.botonesTipo =  BotonTipo.icon;
  }

  ngOnInit() {
    this.cambiarBotonTipo();
  }

  cambiarBotonTipo() {
    // switch (this.botonesTipo) {
    //   case BotonTipo.button:
    //     this.botonesTipo = BotonTipo.icon;

    //     break;
    //   case BotonTipo.icon:
    //     this.botonesTipo = BotonTipo.button;
    //     break;
    // }
    localStorage.setItem('botonesTipo', this.botonesTipo);
  }
}
